import Vue from 'vue';
import App from './App';
import VueI18n from 'vue-i18n'
import Element from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import enLocale from 'element-ui/lib/locale/lang/en'
import zhLocale from 'element-ui/lib/locale/lang/zh-CN'
import ElementLocale from 'element-ui/lib/locale'
import Vant from 'vant';
import 'vant/lib/index.css';
import VueMoment from 'vue-moment';
import accounting from 'accounting'
import * as changeCase from 'change-case'
import dayjs from 'dayjs'
import 'dayjs/locale/zh-cn' // 导入本地化语言
dayjs.locale('zh-cn') // 使用本地化语言

import './permission'; // 权限
import './directives'; // 引入Dialog可拖拽
import store from './store/index';
import * as filters from './filters'; // 全局filter
import './styles/common.scss';
import './styles/font.css';
import codeSetConst from './const/codeSet';
import {getDicts} from '@/api/sys/code';
import loading from './util/loading';
import XEUtils from 'xe-utils'
import VXETable from 'vxe-table'
import VXETablePluginElement from 'vxe-table-plugin-element'
import zhCN from 'vxe-table/lib/locale/lang/zh-CN'
import enUS from 'vxe-table/lib/locale/lang/en-US'
import 'vxe-table-plugin-element/dist/style.css'
import 'vxe-table/lib/index.css'
import './styles/public.scss'
import './styles/themes/themes.scss';
import './styles/setButton.scss'
import './styles/narrowUI.scss'
import './styles/salarySheet.scss'
import '@/assets/font/font.scss'
import './styles/policy.scss'
import './assets/icon/iconfont.js'
import VXEUtils from 'vxe-utils'
import * as echarts from 'echarts'
import Driver from 'driver.js'
import 'driver.js/dist/driver.min.css'
import router from './router/router';
import 'font-awesome/css/font-awesome.min.css'
import './styles/common-v2.scss';
import './styles/login.scss';
import './styles/mobile.scss';
// mounts 可以设置['cookie', 'browse', 'locat']
Vue.use(VXEUtils, XEUtils, {mounts: ['cookie']})
Vue.config.productionTip = false;

Vue.use(Element);
Vue.use(Vant);
Vue.use(VueMoment);

import { message } from './resetMessage';
Vue.prototype.$message = message; //重写message提示框

Vue.use(VXETable);
VXETable.use(VXETablePluginElement)
// 自定义全局的格式化处理函数
VXETable.formats.mixin({
  formatCode ({ cellValue }) {
    let dicts1 = sessionStorage.getItem('dicts') ? JSON.parse(sessionStorage.getItem('dicts')).content : null;
    if (cellValue&&dicts1 && dicts1.codeMap) {
      if(cellValue ===0||cellValue =="0"){
        return "";
      }else {
        return dicts1.codeMap[cellValue ]? dicts1.codeMap[cellValue ]:cellValue ;
      }
    }else if(dicts1){
      return dicts1[cellValue ]
    }
  },
})
Vue.prototype.$day = dayjs
Vue.prototype.$accounting = accounting
Vue.prototype.$changeCase = changeCase
Vue.prototype.getDicts = getDicts;
Vue.prototype.$Loading = loading;
Vue.prototype.$codeSetConst = codeSetConst;
Vue.prototype.$echarts = echarts
Vue.prototype.$driver = new Driver({
	allowClose: false,
	className: 'scoped-class', // className to wrap driver.js popover
  animate: true,
  doneBtnText: '完成',              // Text on the final button
  closeBtnText: '关闭',            // Text on the close button for this step
  stageBackground: 'salmon',       // Background color for the staged behind highlighted element
  nextBtnText: '下一步',              // Next button text for this step
  prevBtnText: '上一步',          // Previous button text for this step
})

Object.keys(filters).forEach((key) => {
  Vue.filter(key, filters[key]);
});

const languageZh = require('./assets/languages/language-zh')
const languageEh = require('./assets/languages/language-en')
const i18n = new VueI18n({
  locale: 'zh', // 将要切换的语言，可以通过url拼的参数获取，用户行为select选择获取，本地manifest配置获取等，根据场景动态获取
  messages: {
    'zh': {
      ...zhLocale,
      ...languageZh,
      ...zhCN
    },  // 本地资源文件，我这里配2个语言，中文&英文，src下根据个人情况放置
    'en': {
      ...enLocale,
      ...languageEh,
      ...enUS
    }
  }
});
ElementLocale.i18n((key, value) => i18n.t(key, value))
VXETable.setup({
  // 对组件内置的提示语进行国际化翻译
  i18n: (key, args) => i18n.t(key, args)
})

// air组件
import air from '@/air/components'
Vue.use(air)

import mixin from './mixin'
Vue.mixin(mixin)

// 自定义原型方法
Array.prototype.removeIndex = function (index) {
  if (index > -1) {
    this.splice(index, 1)
  }
}
Array.prototype.remove = function (val) {
  let index = this.indexOf(val)
  this.removeIndex(index)
}
Array.prototype.removeBy = function (key, val) {
  let indexFlag = -1
  this.forEach((item, index) => {
    if (item[key] === val) {
      indexFlag = index
    }
  })
  if (indexFlag > -1) {
    this.removeIndex(indexFlag)
  }
}
Array.prototype.insert = function (index, val) {
  this.splice(index + 1, 0, val)
}

new Vue({
  router,
  store,
  i18n,
  render: h => h(App),
}).$mount('#app');
Vue.prototype.resetSetItem = function (key, newVal) {
  if (key === 'sockedMsgContent') {
    // 创建一个StorageEvent事件
    var newStorageEvent = document.createEvent('StorageEvent');
    const storage = {
      setItem: function (k, val) {
        sessionStorage.setItem(k, val);

        // 初始化创建的事件
        newStorageEvent.initStorageEvent('setItem', false, false, k, null, val, null, null);

        // 派发对象
        window.dispatchEvent(newStorageEvent)
      }
    }
    return storage.setItem(key, newVal);
  }
};

//做跨域处理的
let parentDomain = window.location.hostname;
document.domain = parentDomain;
// export default i18n
